export default function CityTravelTimingSection({
  city,
  data,
}: {
  city: string;
  data: {
    title: string;
    intro: string;
    cards: {
      icon: string;
      title: string;
      subtitle: string;
      description: string;
      tip: string;
    }[];
    callout?: {
      icon: string;
      title: string;
      description: string;
    };
  };
}) {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Regional Travel Expertise
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            {data.title}
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            {data.intro}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12">
          {data.cards.map((card, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-7 border border-gray-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className={`${card.icon} text-[#1A365D] text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">
                    {card.title}
                  </h3>
                  <p className="text-gray-400 text-xs">{card.subtitle}</p>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">
                {card.description}
              </p>
              <div className="flex items-start gap-2 bg-[#F6C344]/8 rounded-md p-3">
                <i className="ri-lightbulb-flash-line text-[#F6C344] text-sm flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-600 text-xs leading-relaxed">
                  <strong className="text-[#1A365D]">Passport tip:</strong>{" "}
                  {card.tip}
                </p>
              </div>
            </div>
          ))}
        </div>

        {data.callout && (
          <div className="bg-[#1A365D] rounded-lg p-7 flex flex-col md:flex-row items-center gap-6">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
              <i className={`${data.callout.icon} text-[#F6C344] text-2xl`}></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-bold text-white text-base mb-2">
                {data.callout.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">
                {data.callout.description}
              </p>
            </div>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
            >
              Get Started{" "}
              <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}